module.exports = __webpack_public_path__ + "156f7d7cceb5e9d068ac93420ddf57f7.jpg";